import React, { useContext, useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import ggLogo from "../img/gg-logo.png";
import LoginContext from "../context/LoginContext";
import axios from "../axios";

function Navbar() {
  const navigate = useNavigate();
  const [cookies, setCookies] = useCookies();
  const { isLoggedIn, setIsLoggedIn } = useContext(LoginContext);
  const { pathname } = useLocation();
  const [showResponsiveNav, setShowResponsiveNav] = useState(false);
  const [userRole, setUserRole] = useState(localStorage.getItem("userRole"));

  const handleLogout = () => {
    setCookies("access_token", "");
    localStorage.removeItem("userRole");
    setIsLoggedIn(false);
    navigate("/mixer");
  };

  useEffect(() => {
    setUserRole(localStorage.getItem("userRole"));
  }, [isLoggedIn]);

  useEffect(() => {
    setShowResponsiveNav(false);
  }, [pathname]);

  useEffect(() => {
    const checkLoggedIn = async () => {
      try {
        const response = await axios.get("/users/checkToken", {
          headers: { "x-access-token": cookies.access_token },
        });
        if (response.data.message === "Valid") {
          setIsLoggedIn(true);
        } else {
          //console.log(response.data.message);
          handleLogout();
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (
      pathname !== "/mixer" &&
      pathname !== "/login" &&
      pathname.substring(0, pathname.indexOf("/", 1)) !== "/resetPassword"
    ) {
      //console.log(pathname);
      checkLoggedIn();
    }
  }, []);

  const AdminNav = () => {
    return (
      <div
        className={
          showResponsiveNav
            ? "navbar-header responsiveNav no-print"
            : "navbar-header no-print"
        }
      >
        <div
          className="navBurger"
          onClick={() => setShowResponsiveNav(!showResponsiveNav)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="#ffffff"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg>
        </div>
        <div className="navItemContainer">
          <NavLink to="/mixer" className="navItem">
            Mixer
          </NavLink>
          <NavLink to="/formulas" className="navItem">
            Formulas
          </NavLink>
          <NavLink to="/users" className="navItem">
            Users
          </NavLink>
          <NavLink to="/lists" className="navItem">
            My Lists
          </NavLink>
          <div onClick={handleLogout} id="logout" className="navItem">
            Logout
          </div>
        </div>
      </div>
    );
  };

  const UserNav = () => {
    return (
      <div
        className={
          showResponsiveNav
            ? "navbar-header responsiveNav no-print"
            : "navbar-header no-print"
        }
      >
        <div
          className="navBurger"
          onClick={() => setShowResponsiveNav(!showResponsiveNav)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="#ffffff"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg>
        </div>
        <div className="navItemContainer">
          <NavLink to="/mixer" className="navItem">
            Mixer
          </NavLink>
          <NavLink to="/lists" className="navItem">
            My Lists
          </NavLink>
          <div onClick={handleLogout} id="logout" className="navItem">
            Logout
          </div>
        </div>
      </div>
    );
  };

  return (
    <nav role="navigation" className="navbar topnavbar col-md-12 no-print">
      <img
        src={ggLogo}
        alt="Fusion Mixer Logo"
        className="brand-logo"
        height={61}
        style={{ cursor: "pointer" }}
        onClick={() => navigate("/mixer")}
      />
      {isLoggedIn ? (
        userRole === "ADMIN" ? (
          <AdminNav />
        ) : (
          <UserNav />
        )
      ) : (
        <div
          className={
            showResponsiveNav
              ? "navbar-header responsiveNav no-print"
              : "navbar-header no-print"
          }
        >
          <div
            className="navBurger"
            onClick={() => setShowResponsiveNav(!showResponsiveNav)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="#ffffff"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </div>
          <div className="navItemContainer">
            <div
              id="login"
              className="navItem"
              onClick={() => navigate("/login")}
            >
              Login
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
